<template>
    <form id="printJS-form1">
        <div ref="printer_doc" id="printer2">
        </div>
    </form>
</template>
<script>
import printJS from 'print-js'
export default {
    name: 'print',
    props: {
        // html: {
        //     type: String,
        //     default: ""
        // }
    },
    watch: {
        // html(val) {
        //     if (val) {
        //         this.setBodyHtml(val);
        //     }
        // }
    },
    created() {},
    beforeDestroy() {

    },
    data() {
        return {

        }
    },
    methods: {
        wsFunc(e) {},
        setBodyHtml2(html) {
            // const doc = document.getElementById('printer2')
            let doc = this.$refs.printer_doc
            console.log(doc)
            doc.innerHTML = ''
            doc.innerHTML = html
            doc.style.display = "block";
            doc.style.width = "100%";
            doc.id = "temp01"
            //doc.querySelector('div').style.width="100%";
            //console.log(doc.querySelector('div'))

            this.handleSpinCustom()
            setTimeout(() => {
                printJS({
                    printable: 'temp01',
                    type: 'html',
                    targetStyles: ['*'], //继承页面要打印元素原有的css属性
                    //ignoreElements:[],//传入要打印的div中的子元素id，使其不打印。
                    //style: '.img-rules { top: -150px;}'
                    scanStyles: true, //不适用默认样式
                    style: '',
                    // style: '@page {margin: 0 10mm};', //去除页眉页脚
                    //ignoreElements:[''],//Accepts an array of html ids that should be ignored when printing a parent html element.
                    onLoadingStart: () => console.log("loading start"),
                    onLoadingEnd: () => { this.$Spin.hide();
                        console.log("loading end") },
                    onError: function(error) {
                        alert('Error found => ' + error.message)
                    },
                    fallbackPrintable: () => console.log("FallbackPrintable"),
                    onPrintDialogClose: () => console.log('The print dialog was closed'),
                })
                this.$Spin.hide()
                //控制客服图标显示
                // document.getElementById('ECHAT_mini_icon').style.display = "block"
                console.log("TimeOut Executado");
                //隐藏
                doc.style.display = "none";
            }, 3000)


        },
        handleSpinCustom() {
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                size: 20,
                            }
                        }),
                        h('div', {
                            style: {
                                fontSize: "18px",
                                fontFamily: "Source Han Sans CN",

                            }
                        }, "正在加载打印数据")
                    ])
                }
            });
            ////控制客服图标隐藏
            // document.getElementById('ECHAT_mini_icon').style.display = "none"
        }


    }

}
</script>
<style lang="less" media="print">
#iframe {
    height: 600px;
    overflow: auto;
}

.logo {
    height: 13px;
    width: 13px;
    vertical-align: text-top;
}

.noprint {
    display: block;
}
</style>